function updateStatus(vm) {
  let feedback = {
    text: '',
    type: ''
  };

  if(navigator.onLine) {
    feedback = {
      text: 'Oba! Sua conexão com a internet foi reestabelecida.',
      type: 'success'
    };
  } else {
    feedback = {
      text: 'Ops! Parece que sua conexão com a internet foi perdida.',
      type: 'danger'
    };
  }

  vm.$refs.me_stacked_toast.createToast(feedback.text, feedback.type);
};

function disconnectionWatcher(vm) {
  window.addEventListener('online', () => updateStatus(vm));
  window.addEventListener('offline', () => updateStatus(vm));
};

export default disconnectionWatcher;
